/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var gramaticaOpt = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,13],$V1=[1,14],$V2=[17,23,25],$V3=[21,24],$V4=[2,13],$V5=[1,32],$V6=[1,55],$V7=[1,63],$V8=[1,61],$V9=[1,56],$Va=[1,57],$Vb=[1,62],$Vc=[1,64],$Vd=[1,59],$Ve=[1,60],$Vf=[13,19,26,30,37,40,44,45,49,51],$Vg=[1,75],$Vh=[2,30],$Vi=[1,85],$Vj=[1,83],$Vk=[1,84],$Vl=[12,15,21,24,27,41,45,46,47,48,52,53,54,55],$Vm=[10,17,23],$Vn=[5,23,25],$Vo=[1,98],$Vp=[13,19,26,44,45];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"init":3,"l_instr":4,"EOF":5,"encabezado":6,"l_funcion":7,"l_importacion":8,"l_declaracion":9,"#":10,"INCLUDE":11,"<":12,"IDENTIFICADOR":13,".":14,">":15,"declaracion":16,"DOUBLE":17,"[":18,"NUMBER":19,"]":20,";":21,"l_dec":22,"INT":23,",":24,"VOID":25,"(":26,")":27,"{":28,"l_instruccion":29,"}":30,"MAIN":31,"instruccion":32,"asignacion":33,"if":34,"salto":35,":":36,"PRINTF":37,"CADENA":38,"operando":39,"RETURN":40,"=":41,"opr":42,"cast":43,"FMOD":44,"-":45,"+":46,"*":47,"/":48,"IF":49,"relacional":50,"GOTO":51,"MEI":52,"MAI":53,"II":54,"DIF":55,"CHAR":56,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",10:"#",11:"INCLUDE",12:"<",13:"IDENTIFICADOR",14:".",15:">",17:"DOUBLE",18:"[",19:"NUMBER",20:"]",21:";",23:"INT",24:",",25:"VOID",26:"(",27:")",28:"{",30:"}",31:"MAIN",36:":",37:"PRINTF",38:"CADENA",40:"RETURN",41:"=",44:"FMOD",45:"-",46:"+",47:"*",48:"/",49:"IF",51:"GOTO",52:"MEI",53:"MAI",54:"II",55:"DIF",56:"CHAR"},
productions_: [0,[3,2],[3,1],[4,2],[6,2],[8,8],[8,7],[9,2],[9,1],[16,6],[16,3],[16,3],[22,3],[22,1],[7,8],[7,7],[7,8],[29,2],[29,1],[32,1],[32,1],[32,2],[32,2],[32,4],[32,5],[32,7],[32,3],[32,2],[33,6],[33,4],[39,1],[39,4],[39,4],[39,7],[39,4],[39,6],[39,1],[39,2],[42,1],[42,1],[42,1],[42,1],[34,8],[35,2],[50,1],[50,1],[50,1],[50,1],[50,1],[50,1],[43,1],[43,1],[43,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
 this.$ = $$[$0-1]; return this.$;
break;
case 2:
 this.$ = null;
break;
case 3:
 this.$ = [$$[$0-1], $$[$0]];
break;
case 4:
this.$ = $$[$0-1] + '\n' + $$[$0] + '\n';
break;
case 5:
this.$ = $$[$0-7] + '#' + $$[$0-5] + ' <' + $$[$0-3] + '.' + $$[$0-1] + '>\n';
break;
case 6:
this.$ = '#' + $$[$0-5] + ' <' + $$[$0-3] + '.' + $$[$0-1] + '>\n';
break;
case 7:
this.$ = $$[$0-1] + $$[$0];
break;
case 8: case 13: case 19: case 20: case 30: case 36: case 43: case 46: case 47: case 48: case 49: case 50: case 51: case 52:
this.$ = $$[$0];
break;
case 9:
this.$ = $$[$0-5] + ' ' + $$[$0-4] + '[' + $$[$0-2] + '];\n';
break;
case 10: case 11:
this.$ = $$[$0-2] + ' ' + $$[$0-1] + ';\n';
break;
case 12:
this.$ = $$[$0-2] + ', ' + $$[$0];
break;
case 14: case 16:
this.$ = $$[$0-7]; this.$.push(new FuncionOpt($$[$0-5], $$[$0-1], _$[$0-7].first_line));
break;
case 15:
this.$ = [new FuncionOpt($$[$0-5], $$[$0-1], _$[$0-6].first_line)];
break;
case 17:
 this.$ = $$[$0-1]; this.$.push($$[$0]);
break;
case 18:
 this.$ = [$$[$0]]; 
break;
case 21:
this.$ = new Salto($$[$0-1], _$[$0-1].first_line);
break;
case 22:
this.$ = new Etiqueta($$[$0-1], _$[$0-1].first_line);
break;
case 23:
this.$ = new Llamada($$[$0-3], _$[$0-3].first_line);
break;
case 24:
this.$ = new PrintOpt($$[$0-2], null, _$[$0-4].first_line);
break;
case 25:
this.$ = new PrintOpt($$[$0-4], $$[$0-2] , _$[$0-6].first_line);
break;
case 26:
this.$ = new ReturnOpt(_$[$0-2].first_line);
break;
case 27:
this.$ = new ReturnOpt(_$[$0-1].first_line);
break;
case 28:
this.$ = new AsignacionOpt($$[$0-5], $$[$0-3], $$[$0-2], $$[$0-1], _$[$0-5].first_line);
break;
case 29:
this.$ = new AsignacionOpt($$[$0-3], $$[$0-1], null, null, _$[$0-3].first_line);
break;
case 31: case 32:
this.$ = $$[$0-3] + '[' + $$[$0-1] + ']';
break;
case 33:
this.$ = $$[$0-6] + '[' + '(' + $$[$0-3] + ')' + $$[$0-1] + ']';
break;
case 34:
this.$ = '(' + $$[$0-2] + ')' + $$[$0];
break;
case 35:
this.$ = $$[$0-5] + '(' + $$[$0-3] + ', ' + $$[$0-1] + ')';
break;
case 37:
this.$ = '-' + $$[$0];
break;
case 38:
this.$ = '+';
break;
case 39:
this.$ = '-';
break;
case 40:
this.$ = '*';
break;
case 41:
this.$ = '/';
break;
case 42:
this.$ = new IfOpt($$[$0-5], $$[$0-4], $$[$0-3], $$[$0-1], _$[$0-7].first_line);
break;
case 44:
this.$ = '<';
break;
case 45:
this.$ = '>';
break;
}
},
table: [{3:1,4:2,5:[1,3],6:4,8:5,10:[1,6]},{1:[3]},{5:[1,7]},{1:[2,2]},{7:8,25:[1,9]},{9:10,10:[1,11],16:12,17:$V0,23:$V1},{11:[1,15]},{1:[2,1]},{5:[2,3],23:[1,17],25:[1,16]},{13:[1,18]},{16:19,17:$V0,23:$V1,25:[2,4]},{11:[1,20]},o($V2,[2,8]),{13:[1,21],22:22},{13:[1,24],22:23},{12:[1,25]},{13:[1,26]},{31:[1,27]},{26:[1,28]},o($V2,[2,7]),{12:[1,29]},o($V3,$V4,{18:[1,30]}),{21:[1,31],24:$V5},{21:[1,33],24:$V5},o($V3,$V4),{13:[1,34]},{26:[1,35]},{26:[1,36]},{27:[1,37]},{13:[1,38]},{19:[1,39]},o($V2,[2,10]),{13:[1,40]},o($V2,[2,11]),{14:[1,41]},{27:[1,42]},{27:[1,43]},{28:[1,44]},{14:[1,45]},{20:[1,46]},o($V3,[2,12]),{13:[1,47]},{28:[1,48]},{28:[1,49]},{13:$V6,19:$V7,26:$V8,29:50,32:51,33:52,34:53,35:54,37:$V9,39:58,40:$Va,44:$Vb,45:$Vc,49:$Vd,51:$Ve},{13:[1,65]},{21:[1,66]},{15:[1,67]},{13:$V6,19:$V7,26:$V8,29:68,32:51,33:52,34:53,35:54,37:$V9,39:58,40:$Va,44:$Vb,45:$Vc,49:$Vd,51:$Ve},{13:$V6,19:$V7,26:$V8,29:69,32:51,33:52,34:53,35:54,37:$V9,39:58,40:$Va,44:$Vb,45:$Vc,49:$Vd,51:$Ve},{13:$V6,19:$V7,26:$V8,30:[1,70],32:71,33:52,34:53,35:54,37:$V9,39:58,40:$Va,44:$Vb,45:$Vc,49:$Vd,51:$Ve},o($Vf,[2,18]),o($Vf,[2,19]),o($Vf,[2,20]),{21:[1,72]},{18:$Vg,26:[1,74],36:[1,73],41:$Vh},{26:[1,76]},{19:[1,77],21:[1,78]},{41:[1,79]},{26:[1,80]},{13:[1,81]},{17:$Vi,23:$Vj,43:82,56:$Vk},{26:[1,86]},o($Vl,[2,36]),{19:[1,87]},{15:[1,88]},o($V2,[2,9]),o($Vm,[2,6]),{13:$V6,19:$V7,26:$V8,30:[1,89],32:71,33:52,34:53,35:54,37:$V9,39:58,40:$Va,44:$Vb,45:$Vc,49:$Vd,51:$Ve},{13:$V6,19:$V7,26:$V8,30:[1,90],32:71,33:52,34:53,35:54,37:$V9,39:58,40:$Va,44:$Vb,45:$Vc,49:$Vd,51:$Ve},o($Vn,[2,15]),o($Vf,[2,17]),o($Vf,[2,21]),o($Vf,[2,22]),{27:[1,91]},{13:[1,93],19:[1,92],26:[1,94]},{38:[1,95]},{21:[1,96]},o($Vf,[2,27]),{13:$Vo,19:$V7,26:$V8,39:97,44:$Vb,45:$Vc},{13:$Vo,19:$V7,26:$V8,39:99,44:$Vb,45:$Vc},{21:[2,43]},{27:[1,100]},{27:[2,50]},{27:[2,51]},{27:[2,52]},{13:$Vo,19:$V7,26:$V8,39:101,44:$Vb,45:$Vc},o($Vl,[2,37]),o($Vm,[2,5]),o($Vn,[2,14]),o($Vn,[2,16]),{21:[1,102]},{20:[1,103]},{20:[1,104]},{17:$Vi,23:$Vj,43:105,56:$Vk},{24:[1,107],27:[1,106]},o($Vf,[2,26]),{21:[1,109],42:108,45:[1,111],46:[1,110],47:[1,112],48:[1,113]},o([12,15,21,24,27,45,46,47,48,52,53,54,55],$Vh,{18:$Vg}),{12:[1,115],15:[1,116],50:114,52:[1,117],53:[1,118],54:[1,119],55:[1,120]},{13:[1,121]},{24:[1,122]},o($Vf,[2,23]),o($Vl,[2,31]),o($Vl,[2,32]),{27:[1,123]},{21:[1,124]},{13:$Vo,19:$V7,26:$V8,39:125,44:$Vb,45:$Vc},{13:$Vo,19:$V7,26:$V8,39:126,44:$Vb,45:$Vc},o($Vf,[2,29]),o($Vp,[2,38]),o($Vp,[2,39]),o($Vp,[2,40]),o($Vp,[2,41]),{13:$Vo,19:$V7,26:$V8,39:127,44:$Vb,45:$Vc},o($Vp,[2,44]),o($Vp,[2,45]),o($Vp,[2,46]),o($Vp,[2,47]),o($Vp,[2,48]),o($Vp,[2,49]),o($Vl,[2,34]),{13:$Vo,19:$V7,26:$V8,39:128,44:$Vb,45:$Vc},{13:[1,129]},o($Vf,[2,24]),{27:[1,130]},{21:[1,131]},{27:[1,132]},{27:[1,133]},{20:[1,134]},{21:[1,135]},o($Vf,[2,28]),{35:136,51:$Ve},o($Vl,[2,35]),o($Vl,[2,33]),o($Vf,[2,25]),{21:[1,137]},o($Vf,[2,42])],
defaultActions: {3:[2,2],7:[2,1],81:[2,43],83:[2,50],84:[2,51],85:[2,52]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

  const {AsignacionOpt} = require('../clases/InstruccionOptimizacion/AsignacionOpt');
  const {Etiqueta} = require('../clases/InstruccionOptimizacion/Etiqueta');
  const {FuncionOpt} = require('../clases/InstruccionOptimizacion/FuncionOpt');
  const {IfOpt} = require('../clases/InstruccionOptimizacion/IfOpt');
  const {Llamada} = require('../clases/InstruccionOptimizacion/Llamada');
  const {PrintOpt} = require('../clases/InstruccionOptimizacion/PrintOpt');
  const {ReturnOpt} = require('../clases/InstruccionOptimizacion/ReturnOpt');
  const {Salto} = require('../clases/InstruccionOptimizacion/Salto');
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:// comentario simple línea
break;
case 2:// comentario multiple líneas
break;
case 3:return 11;
break;
case 4:return 17;
break;
case 5:return 23;
break;
case 6:return 31;
break;
case 7:return 56;
break;
case 8:return 25;
break;
case 9:return 37;
break;
case 10:return 40;
break;
case 11:return 49;
break;
case 12:return 51;
break;
case 13:return 44;
break;
case 14:return 52;
break;
case 15:return 53;
break;
case 16:return 54;
break;
case 17:return 55;
break;
case 18:return 47;
break;
case 19:return 48;
break;
case 20:return 45;
break;
case 21:return 46;
break;
case 22:return 26;
break;
case 23:return 27;
break;
case 24:return 28;
break;
case 25:return 30;
break;
case 26:return 18;
break;
case 27:return 20;
break;
case 28:return 21;
break;
case 29:return 36;
break;
case 30:return 14;
break;
case 31:return 24;
break;
case 32:return 41;
break;
case 33:return 12;
break;
case 34:return 15;
break;
case 35:return 10;
break;
case 36: yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 38; 
break;
case 37: yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 'CADENA_COMILLA'; 
break;
case 38:return 19;
break;
case 39:return 13;
break;
case 40:return 5;
break;
case 41:
        //console.error('Error léxico detectado: ' + yy_.yytext + ', en la linea: ' + yy_.yylloc.first_line + ', columna: ' + yy_.yylloc.first_column);

break;
}
},
rules: [/^(?:\s+)/i,/^(?:\/\/.*)/i,/^(?:[/][*][^*]*[*]+([^/*][^*]*[*]+)*[/])/i,/^(?:include\b)/i,/^(?:double\b)/i,/^(?:int\b)/i,/^(?:main\b)/i,/^(?:char\b)/i,/^(?:void\b)/i,/^(?:printf\b)/i,/^(?:return\b)/i,/^(?:if\b)/i,/^(?:goto\b)/i,/^(?:fmod\b)/i,/^(?:<=)/i,/^(?:>=)/i,/^(?:==)/i,/^(?:!=)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:-)/i,/^(?:\+)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\{)/i,/^(?:\})/i,/^(?:\[)/i,/^(?:\])/i,/^(?:;)/i,/^(?::)/i,/^(?:\.)/i,/^(?:,)/i,/^(?:=)/i,/^(?:<)/i,/^(?:>)/i,/^(?:#)/i,/^(?:"[^\"]*")/i,/^(?:'[^\']*')/i,/^(?:[0-9]+(\.[0-9]+)?\b)/i,/^(?:([a-zA-Z])[a-zA-Z0-9_]*)/i,/^(?:$)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = gramaticaOpt;
exports.Parser = gramaticaOpt.Parser;
exports.parse = function () { return gramaticaOpt.parse.apply(gramaticaOpt, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}